import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_LINKS, MARKETING_MORE } from './shell/nav';

const DISCLAIMER =
  'Wellness information, not medical advice. We show what moved alongside what you did, never what caused it. Talk to a clinician before acting on anything here.';

// Two footers, one hairline each.
//  • app: a quiet strip at the end of the content column — disclaimer left,
//    four links right.
//  • marketing: wordmark + disclaimer left, the secondary pages right.
const Footer = ({ variant = 'app' }) => {
  if (variant === 'marketing') {
    return (
      <footer className="border-t border-line py-12 text-sm text-fg-3">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 flex flex-wrap justify-between gap-6">
          <div>
            <div className="font-[700] tracking-[-0.03em] text-[1.2rem] text-fg">Vegetablah</div>
            <p className="mt-2 max-w-[34em]">{DISCLAIMER}</p>
          </div>
          <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Footer">
            {MARKETING_MORE.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-fg transition-colors">{l.label}</Link>
            ))}
          </nav>
        </div>
      </footer>
    );
  }

  return (
    <footer className="mx-auto mt-14 max-w-[1080px] px-4 sm:px-6 lg:px-10">
      <div className="border-t border-line pt-5 pb-6 flex flex-wrap justify-between gap-4 text-sm text-fg-3">
        <p className="max-w-[48em]">{DISCLAIMER}</p>
        <nav className="flex flex-wrap gap-x-[18px] gap-y-2" aria-label="Footer">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-fg transition-colors">{l.label}</Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
